import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { UserProfile } from '../../models/user-profile';
import * as userProfileActions from '../../actions/user-profiles';
import * as userProfileSelectors from '../../selectors/user-profiles';
import { UserProfilesService } from '../../services/user-profiles.service';
import { ProfileService } from '../../../profiles/services/profile.service';
import { Profile } from '../../../profiles/models/profile';
import { MojoWellKnownNames } from '../../../common/constants/mojo-well-known-names';

@Component({
  selector: 'mojo-user-profile-page',
  templateUrl: './user-profiles-page.component.html',
})
export class UsersProfilesPageComponent implements OnInit {
  userProfiles$: Observable<UserProfile[]>;
  loading$: Observable<boolean>;
  error$: Observable<string>;
  profiles$: Observable<Profile[]>;

  constructor(private readonly userProfilesService: UserProfilesService,
    private readonly profileService: ProfileService) {

    this.userProfiles$ = this.userProfilesService.getUserProfiles();
    this.loading$ = this.userProfilesService.getLoading();
    this.profiles$ = this.profileService.getAllProfiles(MojoWellKnownNames.Products.MojoDashboard);
  }

  ngOnInit() {
  }

}
